export default '/build/c61f968c.jpg'